export default {"list":"i4jJm","cols2":"Rhwml","cols3":"_57ySR"};